import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { GamevyAutoSpinStartControl } from "../controls/gamevy-auto-spin-start-control";

export class GamevyAutoSpinStartControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return layer.getFlexiButton("gamevy_auto_spin_start") != null;
    }

    public build(layer: Layers): AbstractControl[] {
        const button = layer.getFlexiButton("gamevy_auto_spin_start");
        return [new GamevyAutoSpinStartControl(button)];
    }
}
